import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PRICE_TIERS = [
  {
    label: "Under $1,000",
    desc: "Affordable original works from emerging African artists.",
    href: "/gallery?price=under-2000",
    img: "https://images.unsplash.com/photo-1581300741129-49680ba5ecc6?crop=entropy&cs=srgb&fm=jpg&w=600&q=70",
  },
  {
    label: "$1,000 – $2,500",
    desc: "Mid-range collector pieces by established voices.",
    href: "/gallery?price=2000-3000",
    img: "https://images.unsplash.com/photo-1624198376649-c121a452d157?crop=entropy&cs=srgb&fm=jpg&w=600&q=70",
  },
  {
    label: "$2,500 and above",
    desc: "Signature works for serious collectors.",
    href: "/gallery?price=above-3000",
    img: "https://images.unsplash.com/photo-1742648592366-b8b0c847fa00?crop=entropy&cs=srgb&fm=jpg&w=600&q=70",
  },
];

export const PriceTiersSection = () => (
  <section data-testid="price-tiers-section" className="px-6 md:px-12 lg:px-24 py-20 bg-[#F4EFE6]/40 border-y border-[#E5E0D8]">
    <p className="label-eyebrow text-[#1E3A8A]">— Browse by Budget</p>
    <h2 className="font-serif-display text-4xl md:text-5xl tracking-tight font-medium mt-2 text-[#111]">
      Find art at your price
    </h2>
    <p className="text-[#555] mt-2 max-w-xl">
      From affordable originals to signature collector pieces.
    </p>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
      {PRICE_TIERS.map((tier) => (
        <Link
          to={tier.href}
          key={tier.label}
          data-testid={`price-tier-${tier.label.split(" ")[0].toLowerCase()}`}
          className="group bg-white border border-[#E5E0D8] hover:border-[#1E3A8A] transition-colors block"
        >
          <div className="hover-zoom-wrap aspect-[16/10] bg-[#F2EDE5]">
            <img src={tier.img} alt={`${tier.label} — African art price tier`} className="hover-zoom w-full h-full object-cover" />
          </div>
          <div className="p-6">
            <p className="label-eyebrow text-[#F4C430] [text-shadow:_0_0_1px_#1E3A8A]">Browse by price</p>
            <h3 className="font-serif-display text-2xl text-[#1E3A8A] mt-2 font-medium">{tier.label}</h3>
            <p className="text-sm text-[#555] mt-2 leading-relaxed">{tier.desc}</p>
            <p className="label-eyebrow text-[#111] mt-5 group-hover:text-[#1E3A8A] transition-colors inline-flex items-center gap-1">
              Browse now <ArrowRight className="w-3 h-3" />
            </p>
          </div>
        </Link>
      ))}
    </div>
  </section>
);
